export default __webpack_public_path__ + "static/media/mern.3da831a2.svg";